import React from 'react';
import { Box } from '@mui/material';

// Generic IconBox component
export const IconBox = ({
  children,
  backgroundColor = 'kit.background.purple',
  size = 32,
}) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: 1,
      backgroundColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'kit.text.mainInverse',
    }}
  >
    {children}
  </Box>
);

// SVG content components
export const UpArrowSvg = ({ isBlack = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="32"
      height="32"
      rx="8"
      fill={isBlack ? '#0F0F0F' : '#4520AB'}
    />
    <path
      d="M7 22.0002L12.7246 15.7828L16.2474 19.6089L20.2106 15.3046L23.8957 11.4281L24 11.0002H19.3299M24.218 10.2646V16.2646"
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

export const CalendarSvg = ({ isBlack = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="32"
      height="32"
      rx="8"
      fill={isBlack ? '#0F0F0F' : '#4520AB'}
    />
    <path
      d="M8.5 12C8.5 11.4477 8.94772 11 9.5 11H22.5C23.0523 11 23.5 11.4477 23.5 12V22C23.5 22.5523 23.0523 23 22.5 23H9.5C8.94772 23 8.5 22.5523 8.5 22V12Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M23.5 14H8.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.2412 11V9"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M20.5 11V9"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const BoltSvg = ({ isBlack = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="32"
      height="32"
      rx="8"
      fill={isBlack ? '#0F0F0F' : '#4520AB'}
    />
    <rect
      x="8.59952"
      y="9.59952"
      width="14.801"
      height="11.801"
      rx="2.39808"
      stroke="white"
      strokeWidth="1.19904"
    />
    <path
      d="M9 14C12.6646 15.1036 18.6849 15.545 23.6582 14"
      stroke="white"
      strokeWidth="1.19904"
    />
    <rect
      x="14.0995"
      y="13.5995"
      width="3.80096"
      height="2.80096"
      rx="0.599521"
      fill="white"
      stroke="white"
      strokeWidth="1.19904"
    />
    <path
      d="M14.2988 7.59961H17.7012C18.3634 7.59961 18.9004 8.13662 18.9004 8.79883V10.4004H13.0996V8.79883C13.0996 8.13662 13.6366 7.59961 14.2988 7.59961Z"
      fill="white"
      stroke="white"
      strokeWidth="1.19904"
    />
    <circle
      cx="23"
      cy="21"
      r="4"
      fill={isBlack ? '#0F0F0F' : '#4520AB'}
      stroke="white"
      strokeWidth="1.19904"
    />
    <path
      d="M21.4912 19.5195L24.5092 22.4152"
      stroke="white"
      strokeWidth="1.19904"
      strokeLinecap="round"
    />
    <path
      d="M24.5088 19.5195L21.4915 22.5072"
      stroke="white"
      strokeWidth="1.19904"
      strokeLinecap="round"
    />
  </svg>
);

export const DirectionsSvg = ({ isBlack = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="32"
      height="32"
      rx="8"
      fill={isBlack ? '#0F0F0F' : '#4520AB'}
    />
    <path
      d="M19 9L26 15.5L19 22M13 9L6 15.5L13 22"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const TimeSvg = ({ isBlack = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="32"
      height="32"
      rx="8"
      fill={isBlack ? '#0F0F0F' : '#4520AB'}
    />
    <path
      d="M16 6.25C21.3848 6.25 25.75 10.6152 25.75 16C25.75 21.3848 21.3848 25.75 16 25.75C10.6152 25.75 6.25 21.3848 6.25 16C6.25 10.6152 10.6152 6.25 16 6.25Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M16.5 9.5V16.5L20.5 20.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

// Specific icon components - now using SVGs directly without IconBox wrapper
export const UpArrowIcon = ({ isBlack = false }) => (
  <UpArrowSvg isBlack={isBlack} />
);

export const CalendarIcon = ({ isBlack = false }) => (
  <CalendarSvg isBlack={isBlack} />
);

export const BoltIcon = ({ isBlack = false }) => <BoltSvg isBlack={isBlack} />;

export const DirectionsIcon = ({ isBlack = false }) => (
  <DirectionsSvg isBlack={isBlack} />
);

export const TimeIcon = ({ isBlack = false }) => <TimeSvg isBlack={isBlack} />;
